<template>
  <div class="container place_order">
    <div class="head_box">
      <div class="logo">
        <router-link to="/" target="_blank">
          <img class="img_item" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div>
      <el-steps class="steps" :active="1" finish-status="success" :align-center="true">
        <el-step title="我的购物车"></el-step>
        <el-step title="确认订单信息"></el-step>
        <el-step title="付款到账"></el-step>
        <el-step title="确认收货"></el-step>
        <el-step title="评价嗮图"></el-step>
      </el-steps>
    </div>
    <div class="main">
      <my-address ref="myAddr" @sureAddress="sureAddress"></my-address>
      <!-- 送货时间 -->
      <div class="content_item bor_dashed">
        <div class="title">
          <span>确认送货时间</span>
          <span class="tit_itr">(送货时间仅供参考，物流服务公司会尽量满足您的要求)</span>
        </div>
        <div class="day_type">
          <div class="day_item" :class="dayId === item.id ? 'active_day' : ''" v-for="(item, index) in dayData" :key="index" @click="dayId = item.id">
            {{ item.value }}
          </div>
          <div class="proposal">
            <span>我们建议送货日期：</span>
            <span class="proposal_time">{{OrderRes.sendGoodsDay}}</span>
            <span>您期望送货日期：</span>
            <el-date-picker v-model="goodsWishSendTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" @change='checkDate'>
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 商品 -->
      <div class="content_item" v-if="showContent">
        <div class="title">
          <span>确认订单信息</span>
          <el-button class="reback_cart" v-if="$route.query.byUrl == 'shopCart'" @click="backShopCart">
            返回购物车修改
          </el-button>
        </div>
        <!-- 表头 -->
        <div class="goods_header">
          <el-checkbox class="check_all" v-model="selectAll" @change="selectAllChange">全选</el-checkbox>
          <span class="item item_name">商品</span>
          <span class="item">单价</span>
          <span class="item">数量</span>
          <span class="item">小计</span>
          <span class="item">备注</span>
        </div>
        <!-- 购物车数据 -->
        <div class="goods_item" v-for="(item, index) in shopCartBrandList" :key="index">
          <div class="brand">
            <el-checkbox @change="chooseBrand(item)" v-model="item.firstCheck">{{ "品牌：" + item.goodsBrandName }}</el-checkbox>
          </div>
          <div class="goods" v-for="(v, i) in item.shoppingCartList" :key="i">
            <!-- 主图 -->
            <div class="item img_item">
              <el-checkbox class="checkbox" @change="chooseLastCart(item)" v-model="v.lastCheck"></el-checkbox>
              <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                <img class="img" v-lazy="v.mainPreviewImageFilePath" alt="图片加载失败" />
              </router-link>
            </div>
            <!-- 商品信息 -->
            <div class="item name_item">
              <div class="goods_name">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <span>{{v.goodsName+" "+v.goodsMixName}}</span>
                </router-link>
              </div>
              <div class="goods_no">
                <router-link :to="{path:'/goodsDetails/'+v.goodsMixSerNo+'.html'}" target="_blank">
                  <span>商品货号：{{v.goodsMixNo}}</span>
                </router-link>
              </div>
              <div class="attr_box">
                <div class="attr_item" v-show="v['attr'+attrItem+'Name']" v-for="attrItem in 4" :key="attrItem">
                  <div class="label">
                    <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="45" :content="v['attr'+attrItem+'Name']" placement="bottom-end">
                      <span>{{v['attr'+attrItem+'Name']}}：</span>
                    </el-tooltip>
                  </div>
                  <div class="value">
                    <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="45" :content="v['attr'+attrItem+'ContentName']" placement="bottom-end">
                      <span>{{v['attr'+attrItem+'ContentName']}}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <!-- 单价 -->
            <div class="item price_item">￥{{ v.salePrice | priceValue }}</div>
            <!-- 数量 -->
            <div class="item">
              <el-input-number size="mini" v-model="v.goodsCount" @change="editShoppingCart(v.id, v.goodsCount)" :min="1" :max="999" :precision="0"></el-input-number>
            </div>
            <!-- 总价 -->
            <div class="item total_item">
              ￥{{ (v.goodsCount * v.salePrice) | priceValue }}
            </div>
            <!-- 备注 -->
            <div class="item">
              <el-input v-model="v.remark" @change="getOrderRes" type="textarea" resize="none" :maxlength="100" show-word-limit :rows="3" placeholder="请先和商家协商一致!"></el-input>
            </div>
          </div>
          <!-- 买家留言 -->
          <div class="leave_msg">
            <div class="right_msg">
              <div class="right_item">
                <span>店铺合计：</span>
                <span class="price">￥{{(item.totalFee - item.disCountFee) | priceValue}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 物流服务 -->
      <div class="content_item" v-if="$store.state.openOrderServiceFee == 1">
        <div class="title">选择服务</div>
        <div class="service_box">
          <el-radio-group v-model="logisticsType" @change="sureSerType">
            <el-radio-button :label="v.value" v-for="(v,i) in logisticsTypeMap" :key="i">
              <el-popover placement="top" width="200" trigger="hover" :content="v.tip">
                <span slot="reference">{{v.test}}</span>
              </el-popover>
            </el-radio-button>
          </el-radio-group>
          <div class="content">
            <div class="item">
              <span class="label">运输费：</span>
              <span class="price">￥{{ OrderRes.freightFee | priceValue }}</span>
            </div>
            <div class="item">
              <span class="label">送装费：</span>
              <span class="price">￥{{ OrderRes.serviceFee | priceValue }}</span>
            </div>
            <div class="calc_price">
              <span>合计：</span><span class="price">￥{{calcServiceTypeFee | priceValue}}</span>
            </div>
          </div>
          <div class="tips">
            <p v-for="(v,i) in logisticsTypeMap" :key="i">
              <span class="label">{{v.test}}：</span>
              {{v.tip}}
            </p>
          </div>
        </div>
      </div>
      <!-- 优惠券使用 -->
      <div class="content_item" v-if="courtesyList && courtesyList.length>0">
        <div class="title">优惠券使用</div>
        <div class="coupon">
          <div :class="{scroll:true,ismore:isMore}">
            <div :class="{item:true,active:v.id===currentCoupon.id}" v-for="(v,i) in courtesyList" :key="i" @click="onChangeCoupon(v)">
              <div class="label" :style="{background:v.courtesyBatchBatchType==1?background[0]:background[1]}">
                <div class="money" v-if="v.courtesyBatchBatchType==1">
                  <span>￥</span>
                  <span class="text">{{v.cardDenomination}}</span>
                </div>
                <div class="available" v-if="v.courtesyBatchBatchType==1">
                  <span>满{{v.cardAllowUseLimitPrice | priceValue}}可用</span>
                </div>
                <div class="money" v-if="v.courtesyBatchBatchType==2">
                  <span class="text">{{v.cardDiscountRate*10}}折</span>
                </div>
              </div>
              <div class="value">
                <div class="head">
                  {{v.courtesyBatchBatchFrom==1?"平台券":"商家券"}}
                </div>
                <div class="date">
                  <span>到期时间：</span>
                  <span>{{v.endTime}}</span>
                </div>
                <div>
                  <span>券编号：</span>
                  <span>{{v.courtesyNo}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="more" v-if="courtesyList && courtesyList.length>4">
            <span class="cur_pointer" @click="isMore = !isMore">
              {{isMore?"点击收起":"点击展开"}}
              <i :class="{icon:true,'el-icon-d-arrow-left':!isMore,'el-icon-d-arrow-right':isMore}"></i>
            </span>
          </div>
          <div class="coupon_rduce">
            <span>优惠券优惠：</span>
            <span class="price">￥{{couponPrice | priceValue}}</span>
          </div>
        </div>
      </div>
      <!-- 创建订单信息 -->
      <div class="submit_info">
        <div class="info_box">
          <div class="info_item">
            <span class="price">{{ OrderRes.goodsMixCount + " " }}</span>
            <span>件商品，商品总金额：</span>
            <span class="price">￥{{ OrderRes.totalFee | priceValue }}</span>
          </div>
          <div class="info_item" v-if="$store.state.openOrderServiceFee == 1">
            <span>服务费：</span>
            <span class="price">￥{{ calcServiceTypeFee | priceValue }}</span>
          </div>
          <div class="info_item" v-if="couponPrice>0">
            <span>优惠券抵扣：</span>
            <span class="price">￥-{{ couponPrice | priceValue }}</span>
          </div>
          <div class="info_item" v-if="OrderRes.memDisCountFee>0">
            <span>会员优惠：</span>
            <span class="price">￥-{{ OrderRes.memDisCountFee | priceValue }}</span>
          </div>
          <div class="info_item total_price">
            <span>应付金额：</span>
            <span class="price">￥{{payFee | priceValue}}</span>
          </div>
          <div class="addr_item">
            <span>{{ "寄送至：" + resAddr }}</span><br />
            <span>{{ "收货人：" + consignee }}</span>
          </div>
        </div>
      </div>
      <div class="submit_btn">
        <el-button type="primary btn" :disabled="!showContent" @click="submitOrder">提交订单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetGoodsMixList,
  GetOrderFee,
  CreateOrder,
} from "@/pages/page1/api/modules/order";
import { EditShopCart } from "@/pages/page1/api/modules/shoppingCart";
import MyAddress from "./address.vue";
export default {
  metaInfo: { title: "订单结算 - 多比商城" },
  name: "placeOrder",
  components: {
    MyAddress,
  },
  data() {
    return {
      showContent: false, //避免展示更新前的数据
      // 地址信息
      regionCode: "",
      deliveryAddrId: "",
      resAddr: "",
      consignee: "",
      addrLength: 0,
      // 送货时间
      dayData: [
        { id: 3, value: "工作日/周末/节假日均可送货" },
        { id: 2, value: "仅周末、节假日送货" },
        { id: 1, value: "仅工作日送货" },
      ],
      dayId: 3,
      goodsWishSendTime: undefined,
      // 获取到的结算信息
      OrderRes: {
        goodsMixCount: 0,
        totalFee: 0,
        disCountFee: 0,
        memDisCountFee: 0,
        sendGoodsDay: undefined,
        serviceFee: 0, //服务费
        freightFee: 0, //运费
      },
      logisticsType: 1, //新的服务类型
      // 优惠券
      courtesyList: [],
      isMore: false,
      background: ["#74A5E7", "#E3BA68", "#E3687F", "#9968E3", "#BCBCBC"],
      currentCoupon: {},
      // 订单相关
      selectAll: false,
      shopCartBrandList: [],
      createOrderId: "", //时间戳 id
      logisticsTypeMap: [
        {
          value: 1,
          test: "多比物流+自提",
          tip: "多比负责物流运输到当地物流点后，由客户自己到物流点提货；运输费由多比代收。",
        },
        {
          value: 2,
          test: "多比物流+多比送装",
          tip: "多比负责物流运输和送装到家，运输费和服务费由多比代收。",
        },
        {
          value: 3,
          test: "客户指定物流",
          tip: "客户指定物流运输到当地物流后，由客户自己到物流点提货；运输费和服务费由客户自付。",
        },
      ],
    };
  },
  mounted() {
    this.createOrderId = this.$route.query.id;
    this.shopCartBrandList = JSON.parse(
      localStorage.getItem("selectGoods_" + this.createOrderId)
    );
    // 如果有服务费
    let resItem = this.shopCartBrandList.find((item) => item.logisticsType);
    if (resItem) this.logisticsType = resItem.logisticsType;

    this.deleteLocalStorage();
    this.getGoodsMixList();
  },
  methods: {
    // 更新商品信息
    getGoodsMixList() {
      let arr = [];
      this.shopCartBrandList.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          arr.push({
            goodsMixId: v.goodsMixId,
            goodsCount: v.goodsCount,
            id: v.id,
          });
        });
      });
      let query = {
        shoppingCartList: arr,
      };
      GetGoodsMixList(query).then((res) => {
        // console.log("更新商品信息", res);
        this.shopCartBrandList = res.data; //补充商品信息
        // 补充费用信息，选中，备注，服务
        this.shopCartBrandList.forEach((item) => {
          this.$set(item, "firstCheck", true);
          this.$set(item, "totalFee", 0);
          this.$set(item, "disCountFee", 0);
          this.$set(item, "logisticsType", this.logisticsType); //同步本地缓存别忘了服务费
          item.shoppingCartList.forEach((v) => {
            this.$set(v, "lastCheck", true);
            this.$set(v, "remark", "");
          });
        });
        localStorage.setItem(
          "selectGoods_" + this.createOrderId,
          JSON.stringify(this.shopCartBrandList)
        ); //本地缓存
        this.showContent = true;
        // 获取地址列表
        this.$refs.myAddr.getAddrList();
      });
    },
    // 地址确认的回调
    sureAddress(obj) {
      // console.log(obj);
      this.regionCode = obj.regionCode;
      this.deliveryAddrId = obj.deliveryAddrId;
      this.resAddr = obj.resAddr;
      this.consignee = obj.consignee;
      this.addrLength = obj.addrLength;
      this.getOrderRes();
    },
    // 购物车
    editShoppingCart(id, goodsCount) {
      if (this.$route.query.byUrl !== "shopCart") {
        localStorage.setItem(
          "selectGoods_" + this.createOrderId,
          JSON.stringify(this.shopCartBrandList)
        );
        this.getOrderRes();
        return;
      }
      let params = {
        id,
        goodsMixCount: goodsCount,
      };
      EditShopCart(params).then((res) => {
        // console.log("更新购物车数量接口", res);
        localStorage.setItem(
          "selectGoods_" + this.createOrderId,
          JSON.stringify(this.shopCartBrandList)
        );
        this.getOrderRes();
      });
    },
    // 全选
    selectAllChange(val) {
      // console.log(val);
      this.shopCartBrandList.forEach((item) => {
        item.firstCheck = val;
        item.shoppingCartList.forEach((v) => {
          v.lastCheck = val;
        });
      });
      this.getOrderRes();
    },
    // 勾选品牌
    chooseBrand(item) {
      // console.log(item);
      item.shoppingCartList.forEach((v) => {
        v.lastCheck = item.firstCheck;
      });
      this.getOrderRes();
    },
    // 购物组合
    chooseLastCart(item) {
      // console.log(item);
      // 处理上一层 找到一个false说明没有全选品牌
      let haveFalse = item.shoppingCartList.find((v) => !v.lastCheck);
      if (!haveFalse) {
        item.firstCheck = true;
      } else {
        item.firstCheck = false;
      }
      this.getOrderRes();
    },
    // 检查日期
    checkDate() {
      if (!this.goodsWishSendTime) {
        return;
      }
      // let time1 = this.OrderRes.sendGoodsDay + " 00:00:00";
      // time1 = new Date(time1).getTime();
      // goodsWishSendTime 由于组件问题是选中天的开始00.00  所以需要加一天 并兼容ie
      let time1 = new Date().getTime();
      let time2 = new Date(this.goodsWishSendTime.replace(/-/g, "/")).getTime();
      time2 += 24 * 60 * 60 * 1000;
      // console.log(time1, time2);
      if (time1 >= time2) {
        this.$alert("“期望送货日期”不得早于“当前日期”", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
          callback: () => {
            this.goodsWishSendTime = undefined;
          },
        });
      }
    },
    // 选择服务类型
    sureSerType() {
      this.getOrderRes();
    },
    // 选中优惠券
    onChangeCoupon(v) {
      if (this.currentCoupon.id == v.id) {
        this.currentCoupon = {};
        return;
      }
      this.currentCoupon = v;
    },
    // 订单
    getOrderRes() {
      let params = {
        regionCode: this.regionCode,
        shoppingCartList: this.selectShopCartList,
        logisticsType: this.logisticsType,
        aloneDo: true,
      };
      GetOrderFee(params).then((res) => {
        // console.log("获取结算价格信息", res);
        if (res.isSuccess === 1) {
          this.courtesyList = res.data[0].courtesyList; //优惠券列表
          for (const key in this.OrderRes) {
            this.OrderRes[key] = res.data[0][key];
          }
          // 一一匹配商家（选中）填价格
          this.shopCartBrandList.forEach((item) => {
            let resItem = res.data[0].detailFeeList.find(
              (v) => item.goodsBrandId === v.goodsBrandId
            );
            item.totalFee = resItem ? resItem.totalFee : 0;
            item.disCountFee = resItem ? resItem.disCountFee : 0;
          });
          // 选中小计之和不等于返回的商品总金额,刷新页面
          if (this.localSubtotal !== res.data[0].totalFee) {
            this.$message("商品信息已变更");
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        } else {
          // 重置
          this.courtesyList = [];
          for (const key in this.OrderRes) {
            this.OrderRes[key] = 0;
          }
          this.OrderRes.sendGoodsDay = undefined;
          this.shopCartBrandList.forEach((item) => {
            item.totalFee = 0;
            item.disCountFee = 0;
          });
          this.$alert(res.message || "地址不在服务区,请重选", "提示", {
            confirmButtonText: "确定",
            type: "warning",
            showClose: false,
          });
        }
      });
    },
    submitOrder() {
      if (!this.shopCartBrandList) {
        this.$alert("请至少去购物车选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      if (this.selectShopCartList.length == 0) {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      if (this.addrLength <= 0) {
        this.$alert("请选择收货地址", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      let params = {
        deliveryAddrId: this.deliveryAddrId, //收货地址id
        deliveryDayType: this.dayId, //期望送货日期
        deliveryTimeType: 1, //期望送货时间
        goodsWishSendTime: this.goodsWishSendTime || this.OrderRes.sendGoodsDay,
        logisticsType: this.logisticsType, //服务类型
        deliveryWay: 1, //运送方式
        shoppingCartList: this.selectShopCartList,
        busOrderList: this.selectBrandList,
        totalFee: this.OrderRes.totalFee,
        freightFee: this.OrderRes.freightFee,
        serviceFee: this.OrderRes.serviceFee,
        disCountFee: this.OrderRes.disCountFee,
        courtesyList: this.currentCoupon.id
          ? this.currentCoupon.id.split(",")
          : undefined, //优惠券列表 暂时单选
      };
      CreateOrder(params).then((res) => {
        // console.log("创建订单接口", res);
        localStorage.removeItem("selectGoods_" + this.createOrderId);
        let query = {
          id: res.data[0].orderBatchId,
          orderNo: res.data[0].orderBatchNo,
        };
        if (this.$store.state.allowPay == 0) {
          let newUrl = this.$router.resolve({
            path: "/personalCenter/myOrderDetail",
            query: { id: res.data[0].orderBatchId },
          });
          window.open(newUrl.href, "_self");
        }
        if (res.data[0].isCanPay == 1 && this.$store.state.allowPay == 1) {
          let newUrl = this.$router.resolve({
            path: "/payType",
            query,
          });
          window.open(newUrl.href, "_self");
        }
        if (res.data[0].isCanPay == 0 && this.$store.state.allowPay == 1) {
          let newUrl = this.$router.resolve({
            path: "/platePay",
            query,
          });
          window.open(newUrl.href, "_self");
        }
      });
    },
    // 避免本地存储大小不够，删除以前的selectGoods_
    deleteLocalStorage() {
      let localArr = [];
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key.indexOf("selectGoods_") != -1) {
          localArr.push(key.substr(12));
        }
      }
      if (localArr.length > 20) {
        // 时间戳只会越来越大，升序排序 删除小于索引20的selectGoods_
        localArr.sort((a, b) => a - b);
        localArr.forEach((v, i) => {
          if (i < 20) {
            localStorage.removeItem("selectGoods_" + v);
          }
        });
      }
    },
    backShopCart() {
      let newUrl = this.$router.resolve("/shopCart");
      window.open(newUrl.href, "_self");
    },
  },
  computed: {
    // 购买商品列表
    selectShopCartList() {
      let arr = [];
      this.shopCartBrandList.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          if (v.lastCheck) {
            arr.push({
              goodsMixId: v.goodsMixId,
              goodsCount: v.goodsCount,
              id: v.id, //直接购买为1 购物车过来为购物记录id 订单过来为订单相关id(无关紧要避免重复)
              remark: v.remark,
            });
          }
        });
      });
      // console.log(arr);
      return arr;
    },
    // 控制全选属性
    shopCartListLength() {
      let arr = [];
      this.shopCartBrandList.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          arr.push({ id: v.id });
        });
      });
      // console.log(arr);
      return arr.length;
    },
    // 品牌订单列表
    selectBrandList() {
      let arr = [];
      this.shopCartBrandList.forEach((item, index) => {
        let resItem = item.shoppingCartList.find((v) => v.lastCheck);
        if (resItem) {
          arr.push({
            goodsBrandId: item.goodsBrandId,
          });
        }
      });
      // console.log(arr);
      return arr;
    },
    // 本地商品小计之和
    localSubtotal() {
      let price = 0;
      this.shopCartBrandList.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          if (v.lastCheck) {
            price += v.salePrice * v.goodsCount;
          }
        });
      });
      return price;
    },
    // 物流价格总计
    calcServiceTypeFee() {
      let price = 0;
      price = this.OrderRes.freightFee + this.OrderRes.serviceFee;
      return price;
    },
    // 优惠券优惠价格
    couponPrice() {
      let price = 0;
      if (typeof this.OrderRes.totalFee !== "number") {
        return price;
      }
      // 如果是采购优惠券
      if (this.currentCoupon.courtesyBatchBatchClass === 2) return price;
      // 满减优惠
      if (this.currentCoupon.courtesyBatchBatchType == 1) {
        price = this.currentCoupon.cardDenomination;
      }
      // 折扣优惠
      if (this.currentCoupon.courtesyBatchBatchType == 2) {
        let totalFee = this.OrderRes.totalFee;
        price =
          totalFee - Math.round(totalFee * this.currentCoupon.cardDiscountRate);
      }
      return price;
    },
    payFee() {
      let price = 0;
      if (typeof this.OrderRes.totalFee !== "number") {
        return price;
      }
      // 运费 服务费 会员优惠 优惠券
      let otherFee =
        this.OrderRes.freightFee +
        this.OrderRes.serviceFee -
        this.OrderRes.memDisCountFee -
        this.couponPrice;
      price = this.OrderRes.totalFee + otherFee;
      return price;
    },
  },
  watch: {
    selectShopCartList: {
      handler(newV, oldV) {
        // console.log(newV);
        if (newV.length == 0) {
          this.selectAll = false;
          return;
        }
        if (newV.length === this.shopCartListLength) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.place_order {
  .head_box {
    margin-top: 37px;
    margin-bottom: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
    .steps {
      width: 630px;
      height: 40px;
      /deep/ .el-step {
        .el-step__head {
          margin-bottom: 12px;
        }
        .el-step__title {
          line-height: 20px;
        }
        .is-success {
          color: rgba(255, 158, 0, 1);
          border-color: rgba(255, 158, 0, 1);
          font-size: 14px;
        }
        .is-process {
          color: rgba(144, 144, 144, 1);
          border-color: rgba(144, 144, 144, 1);
          font-size: 14px;
        }
        .is-wait {
          font-size: 14px;
        }
      }
    }
  }
  .main {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    padding: 40px 24px;
    color: #1a1a1a;
    font-size: 14px;
    margin-bottom: 120px;
    .content_item {
      margin-bottom: 30px;
      position: relative;
      .title {
        font-size: 24px;
        font-weight: bold;
        padding-bottom: 26px;
        .tit_itr {
          font-size: 12px;
          font-weight: 500;
          color: #909090;
          padding-left: 18px;
        }
        .reback_cart {
          width: 132px;
          height: 30px;
          line-height: 30px;
          padding: 0px;
          float: right;
          margin-right: 30px;
          border-radius: 0px;
        }
      }
      .day_type {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        color: #909090;
        .day_item {
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          text-align: center;
          box-sizing: border-box;
          border: 1px solid #909090;
          margin-right: 18px;
          cursor: pointer;
        }
        .active_day {
          border-color: @themeColor;
          color: @themeColor;
        }
        .proposal {
          height: 40px;
          line-height: 40px;
          .proposal_time {
            font-weight: bold;
            color: #1a1a1a;
            padding-right: 18px;
          }
        }
      }
      .goods_header {
        padding-left: 18px;
        height: 40px;
        line-height: 40px;
        background: rgba(244, 244, 244, 1);
        margin-bottom: 8px;
        display: flex;
        .check_all {
          flex: 1;
          /deep/ .el-checkbox__label {
            font-size: 14px;
          }
        }
        .item {
          text-align: center;
          display: inline-block;
          flex: 1;
          &:last-child {
            margin-right: 0px;
          }
        }
        .item_name {
          flex: 2;
          text-align: left;
          text-indent: 10px;
        }
      }
      .goods_item {
        .brand {
          padding: 10px 0;
          padding-left: 18px;
          border-bottom: 1px solid rgba(229, 229, 229, 1);
        }
        .goods {
          padding-left: 18px;
          margin: 25px 0;
          display: flex;
          align-items: center;
          .item {
            flex: 1;
            text-align: center;
          }
          .img_item {
            align-self: flex-start;
            text-align: left;
            position: relative;
            .checkbox {
              position: absolute;
              top: 0;
              left: 0;
              width: 32px;
              line-height: 100px;
              display: inline-block;
              font-size: 12px;
            }
            .img {
              margin-left: 32px;
              width: 100px;
              height: 100px;
            }
          }
          .name_item {
            text-align: left;
            flex: 2;
            align-self: flex-start;
            overflow: hidden;
            .goods_name {
              padding-bottom: 10px;
              padding-left: 10px;
              box-sizing: border-box;
              word-break: break-all;
              line-height: 16px;
              a {
                color: #1a1a1a;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }
            .goods_no {
              padding-bottom: 6px;
              padding-left: 10px;
              box-sizing: border-box;
              word-break: break-all;
              font-size: 12px;
              a {
                color: #9c9c9c;
              }
            }
            .attr_box {
              padding: 2px 10px;
              box-sizing: border-box;
              border: 1px solid #ffffff;
              position: relative;
              min-height: 50px;
              .attr_item {
                display: flex;
                color: #9c9c9c;
                font-size: 12px;
                margin-bottom: 6px;
                &:last-child {
                  margin-bottom: 0px;
                }
                .label {
                  width: 80px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  cursor: default;
                }
                .value {
                  margin-left: 10px;
                  width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  cursor: default;
                }
              }
            }
          }
          .price_item {
            font-size: 16px;
          }
          .total_item {
            color: #ff0000;
            font-weight: 800;
            font-size: 16px;
          }
        }
        .leave_msg {
          background: #f4f4f4;
          display: flex;
          justify-content: flex-end;
          padding: 20px;
          .right_msg {
            padding-right: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .right_item {
              margin-bottom: 10px;
              .price {
                color: #ff0000;
                font-size: 14px;
                font-weight: bold;
              }
            }
          }
        }
      }
      .service_box {
        background: #f4f4f4;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: 20px;
        font-size: 12px;
        /deep/ .el-radio-group {
          margin-bottom: 30px;
          .el-radio-button {
            margin-left: 30px;
            .el-radio-button__inner {
              padding: 7px 20px;
              border: 1px solid #dcdfe6;
            }
          }
        }
        .content {
          width: 170px;
          padding-right: 20px;
          .item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            .price {
              color: #ff0000;
              font-size: 14px;
              font-weight: bold;
            }
            .label {
              width: 80px;
            }
          }
          .calc_price {
            text-align: right;
            .price {
              padding-left: 30px;
              font-size: 14px;
              font-weight: bold;
              color: @themeColor2;
            }
          }
        }
        .tips {
          margin-top: 10px;
          color: #bebebe;
          font-size: 12px;
          line-height: 20px;
          .label {
            font-weight: bold;
            color: #a5a5a5;
          }
        }
      }
      .coupon {
        background: #f4f4f4;
        padding: 20px;
        .scroll {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row-reverse;
          height: 100px;
          margin-bottom: 20px;
          overflow-y: hidden;
          .item {
            width: 278px;
            height: 100px;
            box-sizing: border-box;
            border: 2px solid #ffffff;
            border-radius: 7px;
            display: flex;
            margin-top: 20px;
            margin-left: 20px;
            cursor: pointer;
            &:nth-child(-n + 4) {
              margin-top: 0;
            }
            &:nth-child(4n) {
              margin-left: 0;
            }
            .label {
              width: 100px;
              height: 100%;
              border-radius: 5px;
              background-color: #74a5e7;
              color: #ffffff;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              .money {
                font-size: 24px;
                .text {
                  font-size: 30px;
                }
              }
              .available {
                font-size: 12px;
              }
            }
            .value {
              width: calc(100% - 100px);
              box-sizing: border-box;
              height: 100%;
              background-color: #ffffff;
              color: #333333;
              border-radius: 0px 6px 6px 0px;
              box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.11);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;

              font-size: 12px;
              font-weight: 400;
              color: #707070;
              .head {
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 10px;
              }
              .date {
                margin-bottom: 10px;
              }
            }
          }
          .active {
            border-color: #ff0000;
          }
        }
        .ismore {
          height: 220px;
          overflow-y: auto;
        }
        .more {
          padding-left: 60px;
          color: #ffaa00;
          .icon {
            transform: rotate(-90deg);
            -ms-transform: rotate(-90deg); /* IE 9 */
            -moz-transform: rotate(-90deg); /* Firefox */
            -webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
            -o-transform: rotate(-90deg); /* Opera */
          }
        }
        .coupon_rduce {
          padding-right: 20px;
          text-align: right;
          .price {
            color: #ff0000;
            font-weight: bold;
          }
        }
      }
    }
    .bor_dashed {
      padding: 26px 0 40px;
      border-top: 1px dashed #909090;
      border-bottom: 1px dashed #909090;
    }
    .submit_info {
      padding-top: 50px;
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-end;
      .info_box {
        width: 569px;
        box-sizing: border-box;
        padding: 28px 40px 0 10px;
        background: #f4f4f4;
        text-align: right;
        .info_item {
          margin-bottom: 18px;
          font-size: 12px;
          .price {
            color: #ff0000;
            font-size: 14px;
            font-weight: bold;
          }
        }
        .total_price {
          color: #ff0000;
          font-size: 18px;
          font-weight: bold;
          .price {
            font-size: 18px;
          }
        }
        .addr_item {
          font-size: 12px;
          padding-bottom: 40px;
          text-indent: 24px;
          word-break: break-all;
        }
      }
    }
    .submit_btn {
      text-align: right;
      .btn {
        width: 188px;
        height: 36px;
        line-height: 36px;
        padding: 0;
        border-radius: 0px;
      }
    }
  }
}
</style>